export const Attachments = axios => ({
  get (slug) {
    return axios.get(`/v1/profiles/${slug}/attachments`)
  },
  upload (slug, files) {
    const formData = new FormData()
    for (const file of files) {
      formData.append('attachments[]', file)
    }
    return axios.post(`/v1/profiles/${slug}/attachments`, formData)
  },
  delete (slug, attachmentSlug) {
    return axios.delete(`/v1/profiles/${slug}/attachments/${attachmentSlug}`)
  }
})
